import React from "react";
import "./Patio.css";
import { useInView } from "react-intersection-observer";
import { Button } from "../../components/Button/Button";
import SEO from "../../components/SEO";

import heroImage from "../../images/morepics/11419 ST GERMAIN WAY TOPO - The View 10-12-23_019.jpg";
import image1 from "../../images/morepics/420 ChapelWood Court - The View_001.jpg";
import image2 from "../../images/morepics/Salinas - Guerrero and MICO Pool Designs revision 09-21-23_003.jpg";

export default function Patio() {
    const { ref: introRef, inView: introVisible } = useInView();
    const { ref: featureRef, inView: featureVisible } = useInView();

    return (
        <>
            <SEO
                title="Patio Design | MICO Pool Design and Consulting"
                description="Plan a custom patio design with MICO, including pool decks, outdoor dining areas, hardscape layouts, shade features, and lighting concepts."
            />
            <div className="patio" style={{ backgroundImage: `url(${heroImage})` }}>
                <h1 className="patio-header">PATIO DESIGN</h1>
            </div>

            <section className="patio-content">
                <div
                    className={
                        introVisible ? "patio-left patio-left-move" : "patio-left"
                    }
                    ref={introRef}
                >
                    <h2>Luxury Outdoor Living Starts with Layout</h2>
                    <p>
                        We design patios that frame the pool, improve flow, and
                        create comfortable zones for dining, lounging, and
                        entertaining. Every concept is built around your home&apos;s
                        architecture and your lifestyle.
                    </p>
                </div>
                <div className="patio-right-image-wrap">
                    <img
                        className="patio-image"
                        src={image1}
                        alt="High-end patio design with integrated pool deck"
                    />
                </div>
            </section>

            <section className="patio-feature-strip">
                <div>
                    <h3>Elegant Hardscape</h3>
                    <p>Premium pavers and stone selected for style and longevity.</p>
                </div>
                <div>
                    <h3>Shade + Comfort</h3>
                    <p>Smart placement for pergolas, seating walls, and gathering zones.</p>
                </div>
                <div>
                    <h3>Evening Atmosphere</h3>
                    <p>Layered lighting and material contrast for a polished night look.</p>
                </div>
            </section>

            <section className="patio-content patio-content-reverse">
                <div className="patio-left-image-wrap">
                    <img
                        className="patio-image"
                        src={image2}
                        alt="Custom patio concept tied into luxury backyard design"
                    />
                </div>
                <div
                    className={
                        featureVisible
                            ? "patio-right patio-right-move"
                            : "patio-right"
                    }
                    ref={featureRef}
                >
                    <h2>What We Build Into Every Patio Concept</h2>
                    <ul className="patio-list">
                        <li>Clear transitions between house, patio, and pool</li>
                        <li>Defined social zones for dining and relaxation</li>
                        <li>Material recommendations based on climate and usage</li>
                        <li>Drainage-aware grading and practical circulation paths</li>
                        <li>Design continuity across pool, kitchen, and landscape</li>
                    </ul>
                    <div className="patio-cta">
                        <Button
                            buttonStyle="btn--outline"
                            buttonSize="btn--medium"
                            buttonLink="/contact"
                        >
                            Start Your Patio Design
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}
